import React from 'react';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import styles from './ChatbotWidget.module.scss';
import { SnowmanIcon } from './SnowmanIcon';
import { ASSISTANT_DISPLAY_NAME } from './constants';

interface ChatHeaderProps {
	sidebarOpen: boolean;
	setSidebarOpen: (open: boolean) => void;
	toggleOpen: () => void;
	onExpand: () => void;
}

/** Expand + Close buttons — shared across sidebar-open and sidebar-closed states */
const HeaderActions: React.FC<Pick<ChatHeaderProps, 'toggleOpen' | 'onExpand'>> = ({
	toggleOpen,
	onExpand,
}) => (
	<SpaceBetween direction="horizontal" size="xs">
		<button className={styles.headerButton} onClick={onExpand} aria-label="Open full page chat" title="Expand">
			<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
				<path d="M11 2h5v5M7 16H2v-5M16 2L10 8M2 16l6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		</button>
		<button className={styles.headerButton} onClick={toggleOpen} aria-label="Close chatbot" title="Close">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			</svg>
		</button>
	</SpaceBetween>
);

export const ChatHeader: React.FC<ChatHeaderProps> = ({
	sidebarOpen,
	setSidebarOpen,
	toggleOpen,
	onExpand,
}) => (
	<div className={styles.header}>
		{sidebarOpen ? (
			<>
				<button
					className={styles.headerButton}
					onClick={() => setSidebarOpen(false)}
					aria-label="Close menu"
				>
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
						<path d="M13 4L7 10l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</button>
				<div className={styles.headerTitle}>
					<h2 className={styles.headerTitleText}>Menu</h2>
				</div>
			</>
		) : (
			<>
				<button
					className={styles.headerButton}
					onClick={() => setSidebarOpen(true)}
					aria-label="Open menu"
				>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
					</svg>
				</button>
				<div className={styles.headerTitle}>
					<SnowmanIcon size={38} />
					<h2 className={styles.headerTitleText}>{ASSISTANT_DISPLAY_NAME}</h2>
				</div>
			</>
		)}
		<HeaderActions toggleOpen={toggleOpen} onExpand={onExpand} />
	</div>
);
